module.exports = __webpack_public_path__ + "img/shop.339ded18.png";